import App, { Container } from 'next/app'
import React from 'react'
import { Provider } from 'react-redux'
//import { ApolloProvider } from 'react-apollo'
//import withData from '../lib/withData'
import { ThemeProvider } from 'styled-components'
import withReduxStore from '../lib/withReduxStore'
import { theme } from '../utils/styles'
import { withRouter } from 'next/router'
import Page from '../components/Page'

class DataNav extends App {
  static async getInitialProps({ Component, ctx }) {
    const pageProps = Component.getInitialProps ? await Component.getInitialProps(ctx) : {}
    pageProps.query = ctx.query
    return { pageProps }
  }

  render() {
    const { Component, pageProps, reduxStore } = this.props
    return (
      <ThemeProvider theme={theme}>
        <Container>
          {/*<ApolloProvider client={apollo}>*/}
          <Provider store={reduxStore}>
            <Page>
              <Component {...pageProps} />
            </Page>
          </Provider>
          {/*</ApolloProvider>*/}
        </Container>
      </ThemeProvider>
    )
  }
}

export default withRouter(withReduxStore(DataNav))
